<template>
  <WsVersion
    label="變因管理版本列表"
    :localeMode="true"
    :id="$route.params.id"
    :modelName="modelName"
    :versionModelName="versionModelName"
    :fields="versionFields"
    :showFields="showFields"
    :hasExpandSystemClass="hasExpandSystemClass"
    :subList="subList"
    :titleKey="'last_version.name'"
    :hasCatchVersion="hasCatchVersion"
    :itemVersionLinkCreatable="itemVersionLinkCreatable"
    :itemVersionCreatable="itemVersionCreatable"
    :itemVersionReadable="itemVersionReadable"
    :itemEditable="itemEditable"
    :itemLinkCheckable="itemLinkCheckable"
    :itemDeletable="itemDeletable"
    :modeVersions="modeVersions"
    :customParentData="subList.customParentData"
    :filterName="'system_class'"
    :filterSubName="'system_subclass'"
  ></WsVersion>
</template>

<script>
import model from "@/models/change_item_template";
import submodel from "@/models/risk_template";
export default {
  data: () => ({
    modelData: null,
    modelName: model.modelName,
    versionModelName: model.versionModelName,
    // versionModelName: submodel.versionModelName,
    versionFields: model.fields.last_version.fields,
    hasExpandSystemClass: true,
    hasCatchVersion: false,
    itemVersionLinkCreatable: false,
    itemVersionCreatable: false,
    itemVersionReadable: false,
    itemEditable: false,
    itemLinkCheckable: true,
    itemDeletable: false,
    modeVersions: true,
    showFields: [
      "locales",
      "system_classes",
      "system_subclasses",
      "updated_at", 
      "updated_admin", 
    ],
    subList: {
      type: "expandSystemClass",
      label: submodel.label,
      modelName: submodel.modelName,
      modelTemplateName: submodel.modelName,
      modeParent: true,
      modeParentVersions: true,
      fields: submodel.fields,
      titleKey: "name",
      fieldsRead: submodel.fieldsRead,
      searchMode: false,
      hideOnNull: false,
      expandDisable: true,
      modelVersionName: submodel.versionModelName,
      orderBy:submodel.versionTimestampKey,
      hasSequence:true,
      fetchWithParams: true,
      customParentData: (parentData) => {
        if(!parentData) return
        let _system_subclass = parentData.last_version.risk_templates.map(
          (mapItem) => {
            return mapItem.system_subclass;
          }
        );
        let _system_class = parentData.last_version.risk_templates.map(
          (mapItem) => {
            return mapItem.system_class;
          }
        );
        return {
          area: parentData.area,
          system_subclass: _system_subclass,
          system_class: _system_class,
          risk_template: parentData.last_version.risk_templates,
        };
      },
    },
  }),
};
</script>

<style>
</style>